import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    margin-bottom: 1rem;
  }

  > p {
    margin-top: 1rem;
    margin-bottom: 2rem;

    font-weight: bold;
  }

  p.Mui-error {
    margin-top: 0;
  }
`

export const infoWrapper = styled.div`
  display:flex;
  justify-content:end;
`


export const iconWrapper = styled.div`

  max-width:100px;


`;